module.exports = __webpack_public_path__ + "static/media/radioButtonMark.9ef786ee.svg";